// Copy text to the clipboard. Prefers the async Clipboard API (works inside
// dialogs / focus-trapped UIs, unlike the legacy textarea + execCommand path,
// which silently failed in the transfer dialog). Falls back to execCommand for
// insecure contexts / older browsers. Returns whether the copy succeeded.
export async function copyToClipboard(text: string): Promise<boolean> {
    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (e) {
        // Permission/secure-context issue — fall through to the legacy path.
    }

    try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        return ok;
    } catch (e) {
        console.warn('Copy to clipboard failed.', e);
        return false;
    }
}
